import { render, staticRenderFns } from "./ShortVideoCard.vue?vue&type=template&id=1e5e65e4&scoped=true"
import script from "./ShortVideoCard.vue?vue&type=script&lang=js"
export * from "./ShortVideoCard.vue?vue&type=script&lang=js"
import style0 from "./ShortVideoCard.vue?vue&type=style&index=0&id=1e5e65e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e5e65e4",
  null
  
)

export default component.exports